import React from 'react';
import { useLocation } from 'react-router-dom';
import './Accordion.sass';
import AccodionItem from './AccordionItem';

interface Props {
	content: any;
	// content: IAccordionContent[];
	withGaps: boolean;
	isTinyTitle: boolean;
}

// interface IAccordionContent {
// 	title?: string;
// 	body?: string;
// 	scrollID?: string;
// }

function Accordion(props: Props) {

	const { content } = props;
	const pageLocation = useLocation();
	const { hash: HASH } = pageLocation;
	const hash = HASH.substring(1);	

	return (
		content && (
			<div
				className={`uikit-accordion ${
					props.withGaps && 'uikit-accordion--gaps'
				}`}
			>
				{/* .uikit-accordion--gaps will add 2+ column gaps for headings */}
				{content.map((item, index) => (
					<AccodionItem
						key={item.scrollID}
						isTinyTitle={props.isTinyTitle}
						item={item}
						index={index}
						defaultOpen={item.scrollID === hash ? true : index === 0}
					/>
				))}
			</div>
		)
	);
}

export default React.memo(Accordion);
